<template>
  <div class="popup-form">
    <div
      class="content-form-popup"
    >
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
        <div class="blackcolor pop-800">Pridajte poznámku</div>
        <button form="note-create" class="w-button saveformBtn" v-if="!loading">Uložiť</button>

        <v-progress-circular
          class="loading-spinner small transparent"
          indeterminate
          v-else
        ></v-progress-circular>
      </div>

      <form id="note-create" @submit.prevent="saveNote">
        <div class="popup-block">
          <textarea required v-model="clientNote" placeholder="Napíšte si poznámku ku klientovi" rows="20" name="comment[text]" id="comment_text" cols="40" class="ui-autocomplete-input" autocomplete="off" role="textbox" aria-autocomplete="list" aria-haspopup="true"></textarea>
        </div>
        <div class="input-group mt-3">
          <label class="field-label"
          >Pripomenúť ?</label>
          <input
            name="dateOfBirth"
            v-model="noteReminderDate"
            type="date"
            class="text-input w-input date-input"
            maxlength="256"
            :min="today"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ClientNotePopUp",
  props: {
    payload: Object,
  },
  computed: {
    ...mapGetters({
      typeByClientProfile: "clientState/getTypeByClientProfile",
    }),

    today() {
      const d = new Date();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${d.getFullYear()}-${month}-${day}`;
    }
  },
  methods: {
    async saveNote() {
      const noteObject = {
        note: this.clientNote,
        notify_date: this.noteReminderDate,
        finished: false
      }
      try {
        const clientProfile = this.payload.client.client_profile;
        this.loading = true;
        await this.$store.dispatch("clientState/patchClientProfile", {
          id: clientProfile.id,
          type: this.typeByClientProfile(clientProfile),
          profile: {
            client_notes: [...clientProfile.client_notes, noteObject]
          }
        });

        this.$store.commit("popupManagerState/setUserManagerRefresh", true);
        this.closePopup();
      } catch (e) {
        this.$store.commit("appState/setSuccessMessage", {
            text: `Nepodarilo sa uložiť poznámku`,
            type: "error"
          }
        );
      } finally {
        this.loading = false;
      }
    },
    getClientType() {
      switch (this.payload.client.client_profile.ob_status) {
        case "archivovany":
          return "archivedClients";
        case "novy":
          return "temporaryClients";
        case "rozpracovaný":
          return "registeredClients";
      }
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
  data: () => ({
    loading: false,
    clientNote: "",
    noteReminderDate: null,
  }),
}
</script>

<style scoped>

</style>